module.exports = __webpack_public_path__ + "static/Kubernetes-Logo-227485cd22f61dc631fdbdeb26f08756.png";